import React from "react";
import history from "../../../../../../utils/history";
import BackNavigationPanel from "../../../../../ui/back-navigation-panel/BackNavigationPanel";
import MenuTable from "../../../../../ui/menu-table/MenuTable";

interface Props {

}

const PaymentDetailsRequestMenu: React.FC<Props> = () => {
  return (
    <div>
      <BackNavigationPanel
        title={"EMAIL_TEMPLATE_PAYMENT_DETAILS_REQUEST_TEMPLATE_BACK_PANEL_TITLE"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/email-notifications/emails")}>
        <MenuTable
          data={[
            {
              title: "EMAIL_TEMPLATE_PAYMENT_DETAILS_REQUEST_TEMPLATE_TITLE",
              onClick: () => history.push("/configuration/email-notifications/emails/payment-details-request/template")
            }
          ]}
        />
      </BackNavigationPanel>
    </div>
  )
}

export default PaymentDetailsRequestMenu
